import { render } from "./assign_compliance_rules.html?vue&type=template&id=c5a60608&external"
import script from "./assign_compliance_rules.js?vue&type=script&lang=js&external"
export * from "./assign_compliance_rules.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__